import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import {axiosInstance, localAxiosGet } from '../../../../Axios/axios';
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  InputAdornment,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  IconButton,
  Tabs,
  Tab,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Card,
  CardContent,
  Divider,
  Avatar,
  Badge,
  Stack,
  useTheme,
  alpha,
  Collapse,
  TablePagination,
  CircularProgress, Popover,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl as MuiFormControl
} from '@mui/material';
import {
  FileDownloadOutlined as FileDownloadOutlinedIcon,
  Search as SearchIcon,
  FilterList as FilterListIcon,
  Visibility as VisibilityIcon,
  Event as EventIcon,
  AccessTime as AccessTimeIcon,
  MoreVert as MoreVertIcon,
  FileDownload as FileDownloadIcon,
  Print as PrintIcon,
  Close as CloseIcon,
  ArrowBack as ArrowBackIcon,
  DateRange as DateRangeIcon,
  Clear as ClearIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  ErrorOutline as ErrorOutlineIcon,
  HourglassEmpty as HourglassEmptyIcon,
  Person as PersonIcon,
  Business as BusinessIcon,
  Comment as CommentIcon,
  Assignment as AssignmentIcon
} from '@mui/icons-material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { format } from 'date-fns';


const leaveTypeColors = {
  'Casual Leave': '#2196f3',
  'Sick Leave': '#f44336',
  'test leave': '#4caf50',
  'Earned Leave': '#9c27b0',
  'Maternity Leave': '#9c27b0',
  'Paternity Leave': '#673ab7',
};


const statusConfig = {
  'APPROVED': {
    color: '#4caf50',
    bgColor: '#e8f5e9',
    icon: <CheckCircleIcon fontSize="small" />
  },
  'REJECTED': {
    color: '#f44336',
    bgColor: '#ffebee',
    icon: <CancelIcon fontSize="small" />
  },
  'PENDING': {
    color: '#ff9800',
    bgColor: '#fff3e0',
    icon: <HourglassEmptyIcon fontSize="small" />
  },
  'CANCELLED': {
    color: '#757575',
    bgColor: '#f5f5f5',
    icon: <ErrorOutlineIcon fontSize="small" />
  }
};
const formatText = (text) => {
  const firstletterCaptalized = text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  return firstletterCaptalized;
}

// Convert UTC to IST (UTC +5:30)
const convertUTCToIST = (utcDateString) => {
  if (!utcDateString) return null;

  const date = new Date(utcDateString);
  // Add 5 hours 30 minutes to convert UTC to IST
  // const istDate = new Date(date.getTime() + (5 * 60 * 60 * 1000) + (30 * 60 * 1000));
  return date;
};


// Format date for display (IST)
const formatDate = (utcDateString) => {
  if (!utcDateString) return 'N/A';

  const istDate = convertUTCToIST(utcDateString);
  const options = { year: 'numeric', month: 'short', day: 'numeric' };
  return istDate.toLocaleDateString('en-US', options);
};

// Format time for display (IST)
const formatTime = (utcDateString) => {
  if (!utcDateString) return 'N/A';

  const istDate = convertUTCToIST(utcDateString);
  const hours = istDate.getHours().toString().padStart(2, '0');
  const minutes = istDate.getMinutes().toString().padStart(2, '0');
  const seconds = istDate.getSeconds().toString().padStart(2, '0');

  return `${hours}:${minutes}:${seconds}`;
};

// Format both date and time for display
const formatDateTime = (utcDateString) => {
  if (!utcDateString) return 'N/A';

  const istDate = convertUTCToIST(utcDateString);
  const date = formatDate(utcDateString);
  const time = formatTime(utcDateString);

  return `${date} ${time}`;
};

// Keep your existing formatDateForAPI for API calls (it's correct)
const formatDateForAPI = (date) => {
  if (!date) return '';
  const d = new Date(date);
  return d.toISOString().split('T')[0];
};

const LeaveHistory = () => {
  const theme = useTheme();
  const [leaveHistoryData, setLeaveHistoryData] = useState([]);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
  const searchTimeoutRef = useRef(null);
  const [department, setDepartment] = useState('All');
  const [leaveType, setLeaveType] = useState('All');
  const [status, setStatus] = useState('All');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [openFilters, setOpenFilters] = useState(false);
  const [selectedLeave, setSelectedLeave] = useState(null);
  const [detailsDialogOpen, setDetailsDialogOpen] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [locations, setLocations] = useState([]);
  const [selectedLocationFilter, setSelectedLocationFilter] = useState('All');
  const [anchorEl, setAnchorEl] = useState(null);
  const [popoverOpenFordownloadFormat, setPopoverOpenFordownloadFormat] = useState(false);
  const [downloadFormat, setDownloadFormat] = useState('');
  const [departmentsWithIds, setDepartmentsWithIds] = useState([]);
  const [leaveTypesWithIds, setLeaveTypesWithIds] = useState([]);

  const [pagination, setPagination] = useState({
    page: 1,
    rowsPerPage: 10,
    totalPages: '',
  });

  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const token = localStorage.getItem('accessToken');
        const orgId = localStorage.getItem('organizationId');

        if (!token || !orgId) return;

        const response = await axiosInstance(localAxiosGet(`/organization/getAllDepartmentsByOrganizationId/${orgId}`, token));



        if (response.data.status === 'SUCCESS') {
          // Extract departments from the nested structure
          const departments = response.data.message.departments || [];

          setDepartmentsWithIds(departments);
        }
      } catch (error) {
        console.error("Error fetching departments:", error);
      }
    };

    fetchDepartments();
  }, []);

  useEffect(() => {
    fetchLeaveHistory();
  }, [pagination.page, pagination.rowsPerPage, department, leaveType, status, startDate, endDate, selectedLocationFilter, debouncedSearchTerm]);


  const fetchLeaveHistory = async () => {
    try {
      const org_id = localStorage.getItem('organizationId');
      const token = localStorage.getItem('accessToken');


      // Build query parameters
      const params = new URLSearchParams({
        organization_id: org_id,
        page: pagination.page,
        limit: pagination.rowsPerPage
      });

      // Add optional filters if they're not 'All'
      if (debouncedSearchTerm) params.append('name', debouncedSearchTerm);

      // Department filter with ID     
      if (department !== 'All') {
        const selectedDept = departmentsWithIds.find(dept => dept.department === department);
        if (selectedDept) {
          params.append('department_id', selectedDept.id); // Use 'id' field directly
        }
      }

      // Status filter
      if (status !== 'All') params.append('status', status);

      // Leave Type filter with ID
      if (leaveType !== 'All') {
        const selectedLeaveType = leaveTypesWithIds.find(lt => lt.leave_type === leaveType);
        if (selectedLeaveType) {
          params.append('leave_type_id', selectedLeaveType.id);
        }
      }

      // Date filters
      if (startDate) params.append('start_date', startDate.toISOString());
      if (endDate) params.append('end_date', endDate.toISOString());

      // Location filter with ID
      if (selectedLocationFilter !== 'All') {
        const location = locations.find(loc => loc.location_name === selectedLocationFilter);
        if (location) params.append('location_id', location.id);
      }

      const config = localAxiosGet(`organization/getAllLeaveHistoryByOrgId?${params.toString()}`, token);
      const response = await axiosInstance(config);

      if (response.data.status === 'SUCCESS') {
        const result = response.data.result;
        setLeaveHistoryData(result.data || result);

        const paginationData = response.data.result.pagination;
        setPagination(prev => ({
          ...prev,
          totalPages: paginationData.totalPages || 1,
          totalCount: paginationData.totalRecords || 0
        }));
      } else {
        setError('Failed to fetch leave history data');
      }
    } catch (error) {
      setError('Error fetching leave history data: ' + error.message);
    }
  };
  useEffect(() => {
    const fetchLeaveTypes = async () => {
      try {
        const token = localStorage.getItem('accessToken');
        const orgId = localStorage.getItem('organizationId');

        if (!token || !orgId) return;

        const response = await axiosInstance(localAxiosGet(`/organization/getAllLeaveTypes?organization_id=${orgId}`, token));

        // console.log('Leave Types API response:', response.data);

        if (response.data && response.data.status === "SUCCESS") {
          const leaveTypesData = response.data.message.leaveTypes || [];
          setLeaveTypesWithIds(leaveTypesData);
        }
      } catch (error) {
        console.error("Error fetching leave types:", error);
      }
    };

    fetchLeaveTypes();
  }, []);

  useEffect(() => {
    const fetchLocations = async () => {
      try {
        const token = localStorage.getItem('accessToken');
        const orgId = localStorage.getItem('organizationId');

        if (!token || !orgId) return;
        const response = await axiosInstance(localAxiosGet(`/organization/getAllLocationsByOrgId/${orgId}`, token))

        // const response = await axios.get(
        //   `https://hrmsapi.hashstack.in/api/organization/getAllLocationsByOrgId/${orgId}`,
        //   {
        //     headers: {
        //       Authorization: `Bearer ${token}`
        //     }
        //   }
        // );

        if (response.data && response.data.status === "SUCCESS") {
          setLocations(response.data.message);
        }
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchLocations();
  }, []);


  // Create departments array from departmentsWithIds

  const departments = ['All', ...departmentsWithIds.map(dept =>
    dept.department
  )];

  // Create leaveTypes array from leaveTypesWithIds
  const leaveTypes = ['All', ...leaveTypesWithIds.map(lt => lt.leave_type)];

  const statusOptions = ['All', 'APPROVED', 'REJECTED', 'PENDING', 'CANCELLED'];
  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);

  };

  // Then in your useEffect, add the debounce logic:
  useEffect(() => {
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    searchTimeoutRef.current = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
      setPagination(prev => ({ ...prev, page: 1 }));
    }, 500);

    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, [searchTerm]);

  useEffect(() => {
    return () => {
      // This cleanup function runs ONLY when component unmounts
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, []); // Empty dependency array = runs once on mount, cleanup on unmount


  const handleDepartmentChange = (e) => {
    setDepartment(e.target.value);
    setPage(0);
  };

  const handleLeaveTypeChange = (e) => {
    setLeaveType(e.target.value);
    setPage(0);
  };

  const handleStatusChange = (e) => {
    setStatus(e.target.value);
    setPage(0);
  };

  const handleStartDateChange = (date) => {
    setStartDate(date);
    setPage(0);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
    setPage(0);
  };

  const toggleFilters = () => {
    setOpenFilters(!openFilters);
  };

  const clearFilters = () => {
    setDepartment('All');
    setLeaveType('All');
    setStatus('All');
    setStartDate(null);
    setEndDate(null);
    setSelectedLocationFilter('All');
    setSearchTerm('');
    setPagination(prev => ({ ...prev, page: 1 }));
  };

  const handleViewDetails = (leave) => {
    setSelectedLeave(leave);
    setDetailsDialogOpen(true);
  };

  const handleCloseDetailsDialog = () => {
    setDetailsDialogOpen(false);
  };

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  };

  const getStatusChip = (status) => {
    // Convert to uppercase for statusConfig lookup
    const statusKey = status.toUpperCase();

    const config = statusConfig[statusKey] || {
      color: theme.palette.grey[700],
      bgColor: theme.palette.grey[200],
      icon: null
    };

    return (
      <Chip
        size="small"
        label={formatText(status)} // Use formatted text for display
        icon={config.icon}
        sx={{
          color: config.color,
          bgcolor: config.bgColor,
          fontWeight: 500,
          '& .MuiChip-label': { px: 1 },
          '& .MuiChip-icon': { color: 'inherit' }
        }}
      />
    );
  };
  const getLeaveTypeChip = (type) => {
    return (
      <Chip
        size="small"
        label={type}
        sx={{
          backgroundColor: `${leaveTypeColors[type] || theme.palette.grey[500]}15`,
          color: leaveTypeColors[type] || theme.palette.grey[700],
          fontWeight: 500,
          borderRadius: 1,
          '& .MuiChip-label': { px: 1 }
        }}
      />
    );
  };

  // const filteredData = leaveHistoryData.filter(leave => {
  //   const isNameMatch = leave.employee_name.toLowerCase().includes(searchTerm.toLowerCase());
  //   const isDepartmentMatch = department === 'All' || leave.department === department;
  //   const isLeaveTypeMatch = leaveType === 'All' || leave.leave_type === leaveType;
  //   const isStatusMatch = status === 'All' || leave.status === status;
  //   const isLocationMatch = selectedLocationFilter === 'All' || leave.location === selectedLocationFilter;

  //   let isDateMatch = true;
  //   if (startDate && endDate) {
  //     const leaveStart = new Date(leave.start_date);
  //     const leaveEnd = new Date(leave.end_date);
  //     const filterStart = new Date(startDate);
  //     const filterEnd = new Date(endDate);

  //     isDateMatch = (leaveStart >= filterStart && leaveStart <= filterEnd) ||
  //       (leaveEnd >= filterStart && leaveEnd <= filterEnd) ||
  //       (leaveStart <= filterStart && leaveEnd >= filterEnd);
  //   }

  //   return isNameMatch && isDepartmentMatch && isLeaveTypeMatch &&
  //     isStatusMatch && isDateMatch && isLocationMatch;
  // });

  const handleChangePage = (event, newPage) => {
    setPagination(prev => ({
      ...prev,
      page: newPage + 1
    }));
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setPagination(prev => ({
      ...prev,
      rowsPerPage: newRowsPerPage,
      page: 1
    }));
  };




  const handleOpenPopover = (event) => {
    setAnchorEl(event.currentTarget);
    setPopoverOpenFordownloadFormat(true);
  };

  const handleClosePopover = () => {
    setAnchorEl(null);
    setPopoverOpenFordownloadFormat(false);
    setDownloadFormat('');
  };

  const handleFormatChange = (event) => {
    setDownloadFormat(event.target.value);
  };



  const handleDownload = async () => {
    try {
      const org_id = localStorage.getItem('organizationId');
      const token = localStorage.getItem('accessToken');

      // Get the selected location ID
      const selectedLocation = locations.find(loc => loc.location_name === selectedLocationFilter);
      const locationId = selectedLocationFilter === 'All' ? 'All' : (selectedLocation ? selectedLocation.id : 'All');

      // Get the selected department ID     
      let departmentId = 'All';
      if (department !== 'All') {
        const selectedDepartment = departmentsWithIds.find(dept => dept.department === department);
        if (selectedDepartment) {
          departmentId = selectedDepartment.id; // Use 'id' field directly
        }
      }

      // Get the selected leave type ID
      let leaveTypeId = 'All';
      if (leaveType !== 'All') {
        const selectedLeaveType = leaveTypesWithIds.find(lt => lt.leave_type === leaveType);
        if (selectedLeaveType) {
          leaveTypeId = selectedLeaveType.id;
        }
      }


      // Build query parameters object
      const paramsObj = {
        organization_id: org_id,
        department_id: departmentId,
        location_id: locationId,
        leave_type_id: leaveTypeId, // Now using leave_type_id instead of leave_type
        status: status
      };

      // Add dates only if they are selected
      if (startDate) paramsObj.from_date = formatDateForAPI(startDate);
      if (endDate) paramsObj.to_date = formatDateForAPI(endDate);

      const params = new URLSearchParams(paramsObj);


      const endpoint = downloadFormat === 'excel'
        ? `organization/getLeaveHistoryExcel?${params.toString()}`
        : `organization/getLeaveHistoryPDF?${params.toString()}`;

      // console.log('Download endpoint:', endpoint); 
      // console.log('Parameters being sent:', paramsObj); 

      const response = await axiosInstance({
        ...localAxiosGet(endpoint, token),
        responseType: 'blob'
      });

      if (!(response.data instanceof Blob)) {
        throw new Error('Response data is not a Blob');
      }

      // Determine content type and filename
      const contentType = response.headers['content-type'] ||
        (downloadFormat === 'excel'
          ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          : 'application/pdf');
      const extension = downloadFormat === 'excel' ? 'xlsx' : 'pdf';
      let filename = `leave_history_report.${extension}`;

      const contentDisposition = response.headers['content-disposition'];
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
        if (filenameMatch?.[1]) {
          filename = filenameMatch[1];
        }
      }

      // Create and trigger download
      const blob = new Blob([response.data], { type: contentType });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();

      // Cleanup
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);

      // Close popover
      setTimeout(() => {
        setAnchorEl(null);
        setPopoverOpenFordownloadFormat(false);
        setDownloadFormat('');
      }, 1000);

    } catch (error) {
      console.error('Download failed:', error);
      // You might want to show an error message to the user here
      alert('Download failed. Please try again.');
    }
  };


  if (error) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Typography color="error" variant="h6">{error}</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{
      backgroundColor: '#f9fafc',
      p: { xs: 0.5, md: 2 },
      borderRadius: 2,
      minHeight: '100vh'
    }}>
      <Card
        elevation={0}
        sx={{
          mb: 3,
          p: { xs: 0.5, md: 2 },
          background: 'linear-gradient(135deg, #26c6da 0%, #00acc1 100%)',
          color: 'white',
          borderRadius: 2
        }}
      >
        <CardContent>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box>
              <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>
                Leave History
              </Typography>
              <Typography variant="body2">
                Track and view employee leave records
              </Typography>
            </Box>

          </Box>
        </CardContent>
      </Card>
      <Box sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        justifyContent: 'space-between',
        alignItems: { xs: 'flex-start', md: 'center' },
        mb: 3,
        gap: 2
      }}>
        <Typography variant="h6" sx={{ fontWeight: 600, color: '#37474f' }}>
          Employee Leave Records
        </Typography>
        <Box sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          gap: 2,
          width: { xs: '100%', md: 'auto' }
        }}>

          <TextField
            variant="outlined"
            size="small"
            placeholder="Search employee..."
            value={searchTerm}
            onChange={handleSearch}

          />

          <Box sx={{ display: 'flex', gap: 0.5 }}>
            <IconButton onClick={handleOpenPopover}>
              <FileDownloadOutlinedIcon
                sx={{
                  color: theme.palette.primary.main
                }}
              />
            </IconButton>
            {/* <Tooltip title="Print Report">
    <IconButton>
      <PrintIcon 
        sx={{ 
          color:  theme.palette.primary.main
        }} 
      />
    </IconButton>
  </Tooltip> */}
          </Box>
          <Button
            variant="contained"
            startIcon={<FilterListIcon />}
            onClick={toggleFilters}
            size="small"
            sx={{
              borderRadius: 2,
              backgroundColor: openFilters ? theme.palette.primary.dark : theme.palette.primary.main,
              textTransform: 'none',
              boxShadow: 1,
              '&:hover': {
                backgroundColor: theme.palette.primary.dark,
              }
            }}
          >
            Filters {openFilters && '(Active)'}
          </Button>
          <Popover
            open={popoverOpenFordownloadFormat}
            anchorEl={anchorEl}
            onClose={handleClosePopover}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
          >
            <Box sx={{
              p: 1.5,
              display: 'flex',
              alignItems: 'center',
              gap: 2
            }}>
              <MuiFormControl component="fieldset">
                <RadioGroup
                  aria-label="download-format"
                  name="download-format-group"
                  value={downloadFormat}
                  onChange={handleFormatChange}
                >
                  <FormControlLabel value="pdf" control={<Radio />} label="PDF" />
                  <FormControlLabel value="excel" control={<Radio />} label="Excel" />
                </RadioGroup>
              </MuiFormControl>
              <Button
                onClick={handleDownload}
                variant="contained"
                sx={{ mt: 1 }}
                disabled={!downloadFormat}
              >
                Download
              </Button>
            </Box>
          </Popover>

        </Box>
      </Box>

      <Collapse in={openFilters} timeout="auto">
        <Card
          elevation={0}
          sx={{
            p: 3,
            mb: 3,
            borderRadius: 2,
            border: '1px solid #e0e0e0',
            backgroundColor: alpha(theme.palette.background.paper, 0.8),
          }}
        >
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={2}>
              <FormControl fullWidth >
                <InputLabel>Department</InputLabel>
                <Select
                  value={department}
                  onChange={handleDepartmentChange}
                  label="Department"
                  sx={{
                    borderRadius: 2,
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: alpha(theme.palette.primary.main, department !== 'All' ? 0.5 : 0.2),
                    }
                  }}
                >
                  {departments.map(dept => (
                    <MenuItem key={dept} value={dept}>
                      {dept === 'All' ? 'All Departments' : dept}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <FormControl fullWidth >
                <InputLabel>Branch</InputLabel>
                <Select
                  value={selectedLocationFilter}
                  onChange={(e) => setSelectedLocationFilter(e.target.value)}
                  label='Location'
                >
                  <MenuItem value="All">All</MenuItem>
                  {locations.map((item) => (
                    <MenuItem key={item.id} value={item.location_name}>
                      {item.location_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <FormControl fullWidth>
                <InputLabel>Leave Type</InputLabel>
                <Select
                  value={leaveType}
                  onChange={handleLeaveTypeChange}
                  label="Leave Type"
                  sx={{
                    borderRadius: 2,
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: alpha(theme.palette.primary.main, leaveType !== 'All' ? 0.5 : 0.2),
                    }
                  }}
                >
                  {leaveTypes.map(type => (
                    <MenuItem key={type} value={type}>
                      {type === 'All' ? 'All Leave Types' : type}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <FormControl fullWidth >
                <InputLabel>Status</InputLabel>
                <Select
                  value={status}
                  onChange={handleStatusChange}
                  label="Status"
                  sx={{
                    borderRadius: 2,
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: alpha(theme.palette.primary.main, status !== 'All' ? 0.5 : 0.2),
                    }
                  }}
                >
                  {statusOptions.map(option => (
                    <MenuItem key={option} value={option}>
                      {option === 'All' ? 'All Statuses' : formatText(option)}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  size='small'
                  label="From Date"
                  value={startDate}
                  onChange={handleStartDateChange}
                  renderInput={(params) => (
                    <TextField
                      size="small"
                      {...params}
                      fullWidth
                      sx={{
                        height: '40px',
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 2,
                        }
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  size='small'
                  label="To Date"
                  value={endDate}
                  onChange={handleEndDateChange}
                  renderInput={(params) => (
                    <TextField
                      size="small"
                      {...params}
                      fullWidth
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 2,
                        }
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <Button
                variant="outlined"
                onClick={clearFilters}
                fullWidth
                startIcon={<ClearIcon />}
                sx={{
                  borderRadius: 2,
                  height: '100%',
                  borderColor: theme.palette.grey[400],
                  color: theme.palette.text.secondary,
                  textTransform: 'none',
                  '&:hover': {
                    borderColor: theme.palette.text.secondary,
                    backgroundColor: alpha(theme.palette.grey[500], 0.05),
                  }
                }}
              >
                Clear Filters
              </Button>
            </Grid>
          </Grid>


          {(department !== 'All' || leaveType !== 'All' || status !== 'All' || startDate || endDate) && (
            <Box sx={{ mt: 2, display: 'flex', flexWrap: 'wrap', gap: 1 }}>
              <Typography variant="body2" sx={{ color: theme.palette.text.secondary, mr: 1 }}>
                Active Filters:
              </Typography>

              {department !== 'All' && (
                <Chip
                  size="small"
                  label={`Department: ${department}`}
                  onDelete={() => setDepartment('All')}
                  sx={{
                    bgcolor: alpha(theme.palette.primary.main, 0.1),
                    color: theme.palette.primary.main
                  }}
                />
              )}
              {selectedLocationFilter !== 'All' && (
                <Chip
                  size='small'
                  label={`Location: ${selectedLocationFilter}`}
                  onDelete={() => setSelectedLocationFilter('')}
                  sx={{
                    bgcolor: alpha(theme.palette.primary.main, 0.1),
                    color: theme.palette.primary.main
                  }}
                />
              )}

              {leaveType !== 'All' && (
                <Chip
                  size="small"
                  label={`Type: ${leaveType}`}
                  onDelete={() => setLeaveType('All')}
                  sx={{
                    bgcolor: alpha(theme.palette.primary.main, 0.1),
                    color: theme.palette.primary.main
                  }}
                />
              )}

              {status !== 'All' && (
                <Chip
                  size="small"
                  label={`Status: ${status}`}
                  onDelete={() => setStatus('All')}
                  sx={{
                    bgcolor: alpha(theme.palette.primary.main, 0.1),
                    color: theme.palette.primary.main
                  }}
                />
              )}

              {startDate && endDate && (
                <Chip
                  size="small"
                  label={`Date: ${formatDate(startDate)} - ${formatDate(endDate)}`}
                  onDelete={() => {
                    setStartDate(null);
                    setEndDate(null);
                  }}
                  sx={{
                    bgcolor: alpha(theme.palette.primary.main, 0.1),
                    color: theme.palette.primary.main
                  }}
                />
              )}
            </Box>
          )}
        </Card>
      </Collapse>

      <Card
        elevation={0}
        sx={{
          borderRadius: 2,
          overflow: 'hidden',
          border: { xs: 'none', md: '1px solid #e0e0e0' },
          mb: 2
        }}
      >
        <TableContainer>
          <Table sx={{ tableLayout: 'fixed', display: { xs: 'none', md: 'table' } }}>
            <TableHead sx={{ backgroundColor: '#f5f7fa' }}>
              <TableRow>
                <TableCell sx={{
                  fontWeight: 600,
                  color: '#546e7a',
                  py: 1,
                  width: '25%',
                  fontSize: '0.875rem'
                }}>Employee</TableCell>
                <TableCell sx={{
                  fontWeight: 600,
                  color: '#546e7a',
                  py: 1,
                  width: '15%',
                  fontSize: '0.875rem',
                  display: { md: 'none', lg: 'table-cell' } // Hide on md, show on lg+
                }}>Leave Type</TableCell>
                <TableCell sx={{
                  fontWeight: 600,
                  color: '#546e7a',
                  py: 1,
                  width: '15%',
                  fontSize: '0.875rem'
                }}>Period</TableCell>
                <TableCell sx={{
                  fontWeight: 600,
                  color: '#546e7a',
                  py: 1,
                  width: '5%',
                  fontSize: '0.875rem'
                }} align="center">Days</TableCell>
                <TableCell sx={{
                  fontWeight: 600,
                  color: '#546e7a',
                  py: 1,
                  width: '17%',
                  fontSize: '0.875rem'
                }}>Status</TableCell>
                <TableCell sx={{
                  fontWeight: 600,
                  color: '#546e7a',
                  py: 1,
                  width: '12%',
                  fontSize: '0.875rem'
                }}>Applied On</TableCell>
                <TableCell sx={{
                  fontWeight: 600,
                  color: '#546e7a',
                  py: 2,
                  width: '11%',
                  fontSize: '0.875rem'
                }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {leaveHistoryData.map((leave, index) => (
                <TableRow
                  key={index}
                  hover
                  sx={{
                    '&:hover': {
                      backgroundColor: '#f5f9ff'
                    },
                    transition: 'background-color 0.2s'
                  }}
                >
                  <TableCell sx={{
                    borderLeft: `4px solid ${theme.palette.info.main}`,
                    width: '25%',
                    fontSize: '0.8rem'
                  }}>
                    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
                      <Avatar
                        sx={{
                          bgcolor: theme.palette.info.main,
                          width: 32,
                          height: 32,
                          fontSize: '0.875rem',
                          flexShrink: 0
                        }}
                      >
                        {leave.employee_name.split(' ').slice(0, 2).map(n => n[0]).join('')}
                      </Avatar>
                      <Box sx={{ minWidth: 0, flex: 1 }}>
                        <Typography sx={{
                          fontWeight: 500,
                          color: '#37474f',
                          fontSize: '0.875rem',
                          wordWrap: 'break-word',
                          overflowWrap: 'break-word'
                        }}>
                          {leave.employee_name}
                        </Typography>
                        <Typography variant="caption" sx={{
                          color: '#78909c',
                          fontSize: '0.7rem',
                          display: 'block',
                          mt: 0.25
                        }}>
                          {leave.employee_id}
                        </Typography>

                        {/* Leave Type displayed under name for md screens */}
                        <Box sx={{ display: { md: 'block', lg: 'none' }, mt: 0.5, mb: 0.5 }}>
                          {getLeaveTypeChip(leave.leave_type)}
                        </Box>

                        <Chip
                          label={leave.department}
                          size="small"
                          icon={<BusinessIcon fontSize="small" />}
                          sx={{
                            backgroundColor: alpha(theme.palette.info.main, 0.1),
                            color: theme.palette.info.dark,
                            fontWeight: 500,
                            borderRadius: 1,
                            '& .MuiChip-label': {
                              px: 1,
                              fontSize: '0.7rem'
                            },
                            '& .MuiChip-icon': {
                              color: 'inherit',
                              fontSize: '0.7rem'
                            },
                            height: 20,
                            mt: 0.5
                          }}
                        />
                      </Box>
                    </Box>
                  </TableCell>

                  {/* Leave Type column - hidden on md, visible on lg+ */}
                  <TableCell sx={{
                    width: '15%',
                    fontSize: '0.8rem',
                    display: { md: 'none', lg: 'table-cell' }
                  }}>
                    <Box sx={{ wordWrap: 'break-word', overflowWrap: 'break-word' }}>
                      {getLeaveTypeChip(leave.leave_type)}
                    </Box>
                  </TableCell>

                  <TableCell sx={{ width: '15%', fontSize: '0.8rem' }}>
                    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                      <DateRangeIcon fontSize="small" sx={{
                        color: theme.palette.text.secondary,
                        flexShrink: 0,
                        mt: 0.25
                      }} />
                      <Box sx={{ minWidth: 0, wordWrap: 'break-word', overflowWrap: 'break-word' }}>
                        <Typography variant="body2" sx={{
                          fontWeight: 500,
                          fontSize: '0.8rem',
                          wordWrap: 'break-word'
                        }}>
                          {formatDate(leave.start_date)}
                        </Typography>
                        <Typography variant="caption" sx={{
                          color: theme.palette.text.secondary,
                          fontSize: '0.7rem',
                          wordWrap: 'break-word'
                        }}>
                          to {formatDate(leave.end_date)}
                        </Typography>
                      </Box>
                    </Box>
                  </TableCell>
                  <TableCell align="center" sx={{ width: '5%', fontSize: '0.8rem' }}>
                    <Chip
                      label={leave.leave_duration}
                      size="small"
                      sx={{
                        minWidth: 32,
                        height: 22,
                        fontWeight: 600,
                        backgroundColor: alpha(theme.palette.info.main, 0.1),
                        color: theme.palette.info.dark,
                        fontSize: '0.7rem'
                      }}
                    />
                  </TableCell>
                  <TableCell sx={{ width: '17%', fontSize: '0.8rem' }}>
                    <Box sx={{ wordWrap: 'break-word', overflowWrap: 'break-word' }}>
                      {getStatusChip(leave.status)}
                    </Box>
                  </TableCell>
                  <TableCell sx={{ width: '12%', fontSize: '0.8rem' }}>
                    <Typography variant="body2" sx={{
                      fontSize: '0.8rem',
                      wordWrap: 'break-word',
                      overflowWrap: 'break-word'
                    }}>
                      {formatDate(leave.createdAt)}
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ width: '11%', fontSize: '0.8rem' }}>
                    <Stack direction="row" spacing={0.5}>
                      <Tooltip title="View Details">
                        <IconButton
                          size="small"
                          sx={{
                            color: 'white',
                            bgcolor: theme.palette.info.main,
                            '&:hover': {
                              bgcolor: theme.palette.info.dark,
                            },
                            fontSize: '0.8rem'
                          }}
                          onClick={() => handleViewDetails(leave)}
                        >
                          <VisibilityIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                      {/* <Tooltip title="More Options">
                        <IconButton
                          size="small"
                          sx={{
                            color: theme.palette.text.secondary,
                            bgcolor: alpha(theme.palette.grey[500], 0.1),
                            '&:hover': {
                              bgcolor: alpha(theme.palette.grey[500], 0.2),
                            },
                            fontSize: '0.8rem'
                          }}
                        >
                          <MoreVertIcon fontSize="small" />
                        </IconButton>
                      </Tooltip> */}
                    </Stack>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>

          {/* Card view for small screens */}
          <Box sx={{ display: { xs: 'block', md: 'none' }, p: 1 }}>
            {leaveHistoryData.length === 0 ? (
              <Box sx={{ py: 6, textAlign: 'center' }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                  <Box
                    sx={{
                      p: 2,
                      borderRadius: '50%',
                      bgcolor: alpha(theme.palette.info.light, 0.1)
                    }}
                  >
                    <SearchIcon sx={{ fontSize: 48, color: theme.palette.info.light }} />
                  </Box>
                  <Typography variant="h6" sx={{ color: theme.palette.text.secondary, fontSize: '0.875rem' }}>
                    No leave history records found
                  </Typography>
                  <Typography variant="body2" sx={{
                    color: theme.palette.text.disabled,
                    maxWidth: 400,
                    fontSize: '0.8rem'
                  }}>
                    Try adjusting your search or filter criteria to find what you're looking for.
                  </Typography>
                  <Button
                    variant="outlined"
                    startIcon={<ClearIcon />}
                    onClick={clearFilters}
                    sx={{
                      mt: 1,
                      borderRadius: 2,
                      textTransform: 'none',
                      fontSize: '0.8rem'
                    }}
                  >
                    Clear All Filters
                  </Button>
                </Box>
              </Box>
            ) : (
              <Grid container spacing={2}>
                {leaveHistoryData.map((leave, index) => (
                  <Grid item xs={12} sm={6} key={index}>
                    <Card
                      sx={{
                        borderLeft: `4px solid ${theme.palette.info.main}`,
                        borderRadius: 2,
                        '&:hover': {
                          backgroundColor: '#f5f9ff'
                        },
                        transition: 'background-color 0.2s',
                        height: '100%'
                      }}
                    >
                      <CardContent sx={{ p: 2 }}>
                        {/* Employee Info */}
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, mb: 2 }}>
                          <Avatar
                            sx={{
                              bgcolor: theme.palette.info.main,
                              width: 40,
                              height: 40,
                              fontSize: '0.9rem',
                              flexShrink: 0
                            }}
                          >
                            {leave.employee_name.split(' ').slice(0, 2).map(n => n[0]).join('')}
                          </Avatar>
                          <Box sx={{ flex: 1 }}>
                            <Typography sx={{
                              fontWeight: 600,
                              color: '#37474f',
                              fontSize: '0.9rem',
                              mb: 0.5
                            }}>
                              {leave.employee_name}
                            </Typography>
                            <Typography variant="caption" sx={{
                              color: '#78909c',
                              fontSize: '0.75rem',
                              display: 'block'
                            }}>
                              {leave.employee_id}
                            </Typography>
                            <Chip
                              label={leave.department}
                              size="small"
                              icon={<BusinessIcon fontSize="small" />}
                              sx={{
                                backgroundColor: alpha(theme.palette.info.main, 0.1),
                                color: theme.palette.info.dark,
                                fontWeight: 500,
                                borderRadius: 1,
                                '& .MuiChip-label': {
                                  px: 1,
                                  fontSize: '0.7rem'
                                },
                                height: 20,
                                mt: 0.5
                              }}
                            />
                          </Box>
                        </Box>

                        {/* Leave Details */}
                        <Grid container spacing={1.5}>
                          <Grid item xs={6}>
                            <Typography variant="caption" sx={{ color: '#78909c', fontSize: '0.7rem' }}>
                              Leave Type
                            </Typography>
                            <Box sx={{ mt: 0.5 }}>
                              {getLeaveTypeChip(leave.leave_type)}
                            </Box>
                          </Grid>

                          <Grid item xs={6}>
                            <Typography variant="caption" sx={{ color: '#78909c', fontSize: '0.7rem' }}>
                              Days
                            </Typography>
                            <Box sx={{ mt: 0.5 }}>
                              <Chip
                                label={leave.leave_duration}
                                size="small"
                                sx={{
                                  minWidth: 32,
                                  height: 22,
                                  fontWeight: 600,
                                  backgroundColor: alpha(theme.palette.info.main, 0.1),
                                  color: theme.palette.info.dark,
                                  fontSize: '0.7rem'
                                }}
                              />
                            </Box>
                          </Grid>

                          <Grid item xs={12}>
                            <Typography variant="caption" sx={{ color: '#78909c', fontSize: '0.7rem' }}>
                              Period
                            </Typography>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
                              <DateRangeIcon fontSize="small" sx={{ color: theme.palette.text.secondary }} />
                              <Typography variant="body2" sx={{ fontSize: '0.8rem', fontWeight: 500 }}>
                                {formatDate(leave.start_date)} - {formatDate(leave.end_date)}
                              </Typography>
                            </Box>
                          </Grid>

                          <Grid item xs={6}>
                            <Typography variant="caption" sx={{ color: '#78909c', fontSize: '0.7rem' }}>
                              Status
                            </Typography>
                            <Box sx={{ mt: 0.5 }}>
                              {getStatusChip(leave.status)}
                            </Box>
                          </Grid>

                          <Grid item xs={6}>
                            <Typography variant="caption" sx={{ color: '#78909c', fontSize: '0.7rem' }}>
                              Applied On
                            </Typography>
                            <Typography variant="body2" sx={{ fontSize: '0.8rem', fontWeight: 500, mt: 0.5 }}>
                              {formatDate(leave.createdAt)}
                            </Typography>
                          </Grid>
                        </Grid>

                        {/* Actions */}
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2, pt: 1, borderTop: '1px solid #f0f0f0' }}>
                          <Stack direction="row" spacing={1}>
                            <Tooltip title="View Details">
                              <IconButton
                                size="small"
                                sx={{
                                  color: 'white',
                                  bgcolor: theme.palette.info.main,
                                  '&:hover': {
                                    bgcolor: theme.palette.info.dark,
                                  }
                                }}
                                onClick={() => handleViewDetails(leave)}
                              >
                                <VisibilityIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                            {/* <Tooltip title="More Options">
                              <IconButton
                                size="small"
                                sx={{
                                  color: theme.palette.text.secondary,
                                  bgcolor: alpha(theme.palette.grey[500], 0.1),
                                  '&:hover': {
                                    bgcolor: alpha(theme.palette.grey[500], 0.2),
                                  }
                                }}
                              >
                                <MoreVertIcon fontSize="small" />
                              </IconButton>
                            </Tooltip> */}
                          </Stack>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            )}
          </Box>

          {/* Empty state for table view */}
          {leaveHistoryData.length === 0 && (
            <TableRow sx={{ display: { xs: 'none', sm: 'table-row' } }}>
              <TableCell colSpan={7} sx={{ py: 6, textAlign: 'center' }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                  <Box
                    sx={{
                      p: 2,
                      borderRadius: '50%',
                      bgcolor: alpha(theme.palette.info.light, 0.1)
                    }}
                  >
                    <SearchIcon sx={{ fontSize: 48, color: theme.palette.info.light }} />
                  </Box>
                  <Typography variant="h6" sx={{ color: theme.palette.text.secondary, fontSize: '0.875rem' }}>
                    No leave history records found
                  </Typography>
                  <Typography variant="body2" sx={{
                    color: theme.palette.text.disabled,
                    maxWidth: 400,
                    fontSize: '0.8rem'
                  }}>
                    Try adjusting your search or filter criteria to find what you're looking for.
                  </Typography>
                  <Button
                    variant="outlined"
                    startIcon={<ClearIcon />}
                    onClick={clearFilters}
                    sx={{
                      mt: 1,
                      borderRadius: 2,
                      textTransform: 'none',
                      fontSize: '0.8rem'
                    }}
                  >
                    Clear All Filters
                  </Button>
                </Box>
              </TableCell>
            </TableRow>
          )}
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50]}
          component="div"
          count={pagination.totalCount || 0}
          rowsPerPage={pagination.rowsPerPage}
          page={pagination.page - 1} // Convert back to 0-based for MUI
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          sx={{
            borderTop: '1px solid #e0e0e0',
            bgcolor: alpha(theme.palette.background.paper, 0.5),
          }}
        />
      </Card>


      <Dialog
        open={detailsDialogOpen}
        onClose={handleCloseDetailsDialog}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            overflow: 'hidden'
          }
        }}
      >
        {selectedLeave && (
          <>
            <DialogTitle sx={{
              bgcolor: theme.palette.info.main,
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              gap: 1
            }}>
              <IconButton
                size="small"
                onClick={handleCloseDetailsDialog}
                sx={{ color: 'white', mr: 1 }}
              >
                <ArrowBackIcon />
              </IconButton>
              Leave Request Details
            </DialogTitle>
            <DialogContent sx={{ pt: 3, px: 3 }}>
              <Box sx={{ display: 'flex', mb: 3, alignItems: 'center', gap: 2, mt: 2 }}>
                <Avatar
                  sx={{
                    bgcolor: theme.palette.info.main,
                    width: 56,
                    height: 56,
                    fontSize: '1.2rem'
                  }}
                >
                  {selectedLeave.employee_name.split(' ').map(n => n[0]).join('')}
                </Avatar>
                <Box >
                  <Typography variant="h6" sx={{ fontWeight: 600, color: '#37474f' }}>
                    {selectedLeave.employee_name}
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#78909c' }}>
                    ID: {selectedLeave.employee_id} • {selectedLeave.department}
                  </Typography>
                </Box>
                <Box sx={{ ml: 'auto' }}>
                  {getStatusChip(selectedLeave.status)}
                </Box>
              </Box>

              <Divider sx={{ my: 2 }} />

              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <Card
                    variant="outlined"
                    sx={{
                      mb: { xs: 0, md: 2 },
                      borderRadius: 2,
                      borderColor: theme.palette.divider,
                      height: '100%'
                    }}
                  >
                    <CardContent>
                      <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2, color: theme.palette.info.dark }}>
                        <EventIcon fontSize="small" sx={{ mr: 1, verticalAlign: 'text-bottom' }} />
                        Leave Details
                      </Typography>

                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                          <Typography variant="body2" color="textSecondary">
                            Leave Type
                          </Typography>
                          <Box sx={{ mt: 0.5 }}>
                            {getLeaveTypeChip(selectedLeave.leave_type)}
                          </Box>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <Typography variant="body2" color="textSecondary">
                            Duration
                          </Typography>
                          <Typography variant="body1" sx={{ fontWeight: 500, mt: 0.5 }}>
                            {selectedLeave.leave_duration} {selectedLeave.leave_duration > 1 ? 'days' : 'day'}
                          </Typography>
                        </Grid>

                        <Grid item xs={12}>
                          <Typography variant="body2" color="textSecondary">
                            Period
                          </Typography>
                          <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            mt: 0.5,
                            p: 1.5,
                            borderRadius: 1,
                            bgcolor: alpha(theme.palette.info.light, 0.1)
                          }}>
                            <DateRangeIcon sx={{ color: theme.palette.info.main, mr: 1 }} />
                            <Box>
                              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                From: <strong>{formatDate(selectedLeave.start_date)}</strong>
                              </Typography>
                              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                To: <strong>{formatDate(selectedLeave.end_date)}</strong>
                              </Typography>
                            </Box>
                          </Box>
                        </Grid>
                        <Grid item xs={12}>
                          <Typography variant="body2" color="textSecondary">
                            Reason
                          </Typography>
                          <Box sx={{ mt: 0.5 }}>
                            {selectedLeave.leave_reason || ''}
                          </Box>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Card
                    variant="outlined"
                    sx={{
                      mb: 2,
                      borderRadius: 2,
                      borderColor: theme.palette.divider,
                      height: '100%'
                    }}
                  >
                    <CardContent>
                      <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2, color: theme.palette.info.dark }}>
                        <AssignmentIcon fontSize="small" sx={{ mr: 1, verticalAlign: 'text-bottom' }} />
                        Application Details
                      </Typography>

                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <Typography variant="body2" color="textSecondary">
                            Applied On
                          </Typography>
                          <Typography variant="body1" sx={{ fontWeight: 500, mt: 0.5 }}>
                            {formatDate(selectedLeave.createdAt)}
                          </Typography>
                        </Grid>

                        <Grid item xs={12}>
                          <Typography variant="body2" color="textSecondary">
                            Status
                          </Typography>
                          <Box sx={{ mt: 0.5 }}>
                            {getStatusChip(selectedLeave.status)}
                          </Box>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <Typography variant="body2" color="textSecondary">
                            {selectedLeave.status === 'APPROVED' ? 'Approved By' :
                              selectedLeave.status === 'REJECTED' ? 'Rejected By' : ''}
                          </Typography>
                          <Box sx={{ mt: 0.5 }}>
                            {selectedLeave?.approved_by_name || null}
                          </Box>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <Typography variant="body2" color="textSecondary">
                            {selectedLeave.status === 'APPROVED' ? 'Approved on' :
                              selectedLeave.status === 'REJECTED' ? 'Rejected on' : ''}
                          </Typography>
                          <Typography variant="body1" sx={{ fontWeight: 500, mt: 0.5 }}>
                            {selectedLeave.approved_at &&  formatDateTime(selectedLeave.approved_at)}
                          </Typography>
                        </Grid>
                         {selectedLeave?.leave_comment  && (
                        <Grid item xs={12}>
                          <Typography variant="body2" color="textSecondary">
                           Comments
                          </Typography>
                          <Box sx={{ mt: 0.5 }}>
                            {selectedLeave?.leave_comment || ''}
                          </Box>
                        </Grid>
                         )}
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>

                {/* <Grid item xs={12}>
                  <Card 
                    variant="outlined" 
                    sx={{ 
                      borderRadius: 2,
                      borderColor: theme.palette.divider
                    }}
                  >
                    <CardContent>
                      <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2, color: theme.palette.info.dark }}>
                        <CommentIcon fontSize="small" sx={{ mr: 1, verticalAlign: 'text-bottom' }} />
                        Additional Information
                      </Typography>
                      
                      <Box sx={{ 
                        p: 2, 
                        bgcolor: alpha(theme.palette.grey[500], 0.05), 
                        borderRadius: 1
                      }}>
                        <Typography variant="body2" color="textSecondary" gutterBottom>
                          Leave Type ID
                        </Typography>
                        <Typography variant="body1">
                          {selectedLeave.leave_type_id}
                        </Typography>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid> */}
              </Grid>
            </DialogContent>
            <DialogActions sx={{ p: 3, bgcolor: '#f5f7fa', borderTop: '1px solid #e0e0e0' }}>
              <Button
                onClick={handleCloseDetailsDialog}
                variant="outlined"
                startIcon={<CloseIcon />}
                sx={{
                  borderRadius: 2,
                  textTransform: 'none',
                  color: theme.palette.text.secondary,
                  borderColor: theme.palette.divider,
                  '&:hover': {
                    borderColor: theme.palette.text.secondary,
                    bgcolor: alpha(theme.palette.text.secondary, 0.05)
                  }
                }}
              >
                Close
              </Button>
              {/* <Button
                variant="outlined"
                startIcon={<PrintIcon />}
                sx={{
                  borderRadius: 2,
                  textTransform: 'none',
                  color: theme.palette.primary.main,
                  borderColor: theme.palette.primary.main,
                  '&:hover': {
                    borderColor: theme.palette.primary.dark,
                    bgcolor: alpha(theme.palette.primary.main, 0.05)
                  }
                }}
              >
                Print Details
              </Button> */}
            </DialogActions>
          </>
        )}
      </Dialog>
    </Box>
  );
};

export default LeaveHistory;